import React, { Component, Fragment } from 'react';
import InputRange from 'react-input-range';

import { Checklist } from 'components/checklist';
import { Select } from 'components/input';
import { SearchFilter } from 'components/input/search';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import ContentSelectedItem from './ContentSelectedItem';

import './ContentChecklist.scss';

const maxRange = {
  min: 0,
  max: 100
};
const numItemsSelectedDefault = 5;

export default class ContentChecklist extends Component {
  static propTypes = {
    field: PropTypes.string,
    fieldData: PropTypes.object,
    items: PropTypes.array,
    onMenuOpen: PropTypes.func,
    setValue: PropTypes.func,
    clearAll: PropTypes.func,
    max: PropTypes.number,
    min: PropTypes.number,
    changeFilter: PropTypes.func,
    setInputRange: PropTypes.func,
    removeItem: PropTypes.func,
    onChange: PropTypes.func,
    selectedItems: PropTypes.array,
    placeholderSelect: PropTypes.string,
    placeholderSearchInput: PropTypes.string,
    showRange: PropTypes.bool,
    children: PropTypes.node,
    additionalLabel: PropTypes.string
  };

  state = {
    showAllSelectedItems: false
  };

  static defaultProps = {
    selectedItems: [],
    showRange: false,
    min: 0,
    max: 100,
    additionalLabel: ''
  };

  constructor(props) {
    super(props);

    this.onToogleOpen = this.onToogleOpen.bind(this);
  }

  onToogleOpen() {
    const { field, onMenuOpen } = this.props;

    onMenuOpen && onMenuOpen(field);
  }

  toogleShowSelectedItems() {
    this.setState({ showAllSelectedItems: !this.state.showAllSelectedItems });
  }

  isRangeEqual = (min, max) => min === maxRange.min && max === maxRange.max;

  sliderColor = (min, max) =>
    this.isRangeEqual(min, max)
      ? 'input-range__slider--initial'
      : 'input-range__slider--move';

  barColor = (min, max) =>
    this.isRangeEqual(min, max)
      ? 'input-range__track--initial'
      : 'input-range__track--active';

  get InputRangeContentChecklist() {
    const { setInputRange, max, min } = this.props;

    const value = {
      min,
      max
    };

    return (
      <div className="content__checklist__content__input__range">
        <div className="content__checklist__content__input__range__text">
          <I18n label="users_manager.deep_search.content.quiz_score_input_range" />
        </div>
        <InputRange
          allowSameValues
          formatLabel={(value) => `${value}%`}
          maxValue={maxRange.max}
          minValue={maxRange.min}
          value={value}
          onChange={(value) => setInputRange(value)}
          classNames={this.classNames(min, max)}
        />
      </div>
    );
  }

  ItemsFilteredListOptions(hasSelectedItemsThanDefault) {
    const { clearAll } = this.props;

    return (
      <div className="content__checklist__content__input__range__actions">
        <div
          className="content__checklist__content__input__range__action"
          onClick={this.toogleShowSelectedItems.bind(this)}
        >
          {hasSelectedItemsThanDefault &&
            (!this.state.showAllSelectedItems ? (
              <I18n label="general.view_more" />
            ) : (
              <I18n label="general.view_less" />
            ))}
        </div>
        <div
          className="content__checklist__content__input__range__action"
          onClick={clearAll}
        >
          <I18n label="general.clean" />
        </div>
      </div>
    );
  }

  itemsFiltered(selectedItemsFiltered, hasSelectedItemsThanDefault) {
    const { removeItem, showRange } = this.props;

    return (
      <Fragment>
        {showRange && this.InputRangeContentChecklist}

        <div className="content__checklist__content__selected__item">
          {selectedItemsFiltered.map((item) => (
            <ContentSelectedItem
              item={item}
              additionalLabel={item.concluded && item.concluded.label}
              onClose={removeItem}
            />
          ))}
        </div>

        {this.ItemsFilteredListOptions(hasSelectedItemsThanDefault)}
      </Fragment>
    );
  }

  classNames(min, max) {
    return {
      activeTrack: `input-range__track ${this.barColor(min, max)}`,
      disabledInputRange: 'input-range input-range--disabled',
      inputRange: 'input-range',
      labelContainer: 'input-range__label-container',
      maxLabel: 'input-range__label input-range__label--max',
      minLabel: 'input-range__label input-range__label--min',
      slider: `input-range__slider ${this.sliderColor(min, max)}`,
      sliderContainer: 'input-range__slider-container',
      track: 'input-range__track input-range__track--background',
      valueLabel: 'input-range__label input-range__label--value'
    };
  }

  get searchFilter() {
    const { placeholderSearchInput, items, changeFilter, onChange, children } =
      this.props;

    return (
      <div className="subtitle__translation__checklist__panel content__checklist__panel">
        <SearchFilter items={items}>
          <SearchFilter.SearchInput
            wait={0}
            maxLength="100"
            autoComplete="off"
            placeholder={placeholderSearchInput}
            className="content__checklist__panel__input"
            position="right"
            onChange={changeFilter}
          />

          {children ? (
            children
          ) : (
            <Checklist
              className="subtitle__translation__checklist content__checklist__options"
              onChange={onChange}
            >
              <Checklist.Items />
            </Checklist>
          )}
        </SearchFilter>
      </div>
    );
  }

  render() {
    const { fieldData, items, selectedItems, placeholderSelect } = this.props;

    let selectedItemsFiltered = selectedItems;

    const hasSelectedItemsThanDefault =
      selectedItemsFiltered.length > numItemsSelectedDefault;

    if (!this.state.showAllSelectedItems && hasSelectedItemsThanDefault) {
      selectedItemsFiltered = selectedItemsFiltered.slice(
        0,
        numItemsSelectedDefault
      );
    }

    return (
      <div className="content__checklist__container">
        <Select
          name="class"
          classNamePrefix="select"
          placeholder={placeholderSelect}
          onToogleOpen={this.onToogleOpen}
          isOptionDisabled={true}
          isSearchable={false}
          menuIsOpen={false}
          value=""
          options={items}
          marginBottom={false}
          closeClickingOutside={false}
        />
        {fieldData.open && this.searchFilter}
        {Boolean(selectedItemsFiltered.length) &&
          this.itemsFiltered(
            selectedItemsFiltered,
            hasSelectedItemsThanDefault
          )}
      </div>
    );
  }
}
